import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=306174fb&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"
import style0 from "./Info.vue?vue&type=style&index=0&id=306174fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306174fb",
  null
  
)

export default component.exports